import { render, staticRenderFns } from "./societeProfil.vue?vue&type=template&id=b5a33448&"
import script from "./societeProfil.vue?vue&type=script&lang=js&"
export * from "./societeProfil.vue?vue&type=script&lang=js&"
import style0 from "./societeProfil.vue?vue&type=style&index=0&id=b5a33448&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports